module.exports = __webpack_public_path__ + "img/haft-poznan-04.64d3738d.jpg";